import classnames from 'classnames';
import styles from './Statistics.module.scss';

interface StatisticsProps {
  number: string;
  description: string;
  plusColor?: string;
  numberColor?: string;
  descriptionColor?: string;
}

function Statistics({
  number,
  description,
  plusColor = '#9c27b0',
  numberColor = '#ffd700',
  descriptionColor = '#fff',
}: StatisticsProps) {
  return (
    <div className={styles.statistic}>
      <div className={styles.plus} style={{ color: plusColor }}>
        +
      </div>
      <div className={styles.number} style={{ color: numberColor }}>
        de
      </div>
      <div
        className={classnames(styles.number, styles.figure)}
        style={{ color: numberColor }}
      >
        {number}
      </div>
      <div className={styles.description} style={{ color: descriptionColor }}>
        {description}
      </div>
    </div>
  );
}

export default Statistics;
